import { ICareMap, IHouseholdMember, INewCareMap, IPatient } from '../caremap/ICareMap';
import { NameHelper } from '../contact-methods/NameHelper';
import { IAvatarIdentity } from './IAvatarIdentity';

/** Everything a care recipient's avatar needs, so no renderer can take the identity and miss the rest. */
export interface ICareRecipientAvatar {
    identity: IAvatarIdentity;
    name: string;
}

interface IForCareRecipient {
    (careMap: ICareMap | INewCareMap): ICareRecipientAvatar;
    // with no care map yet, an avatar that has not loaded
    (careMap: ICareMap | INewCareMap | undefined): ICareRecipientAvatar | { identity: undefined; name: string; };
}

export class AvatarIdentityFactory {
    static inject = () => [NameHelper];
    constructor(private names: NameHelper) {}

    // A care recipient or care map member as the api sent them, link included. A photo still
    // previewing from photoDataURI is not drawn.
    forMember = (member: IPatient | IHouseholdMember): IAvatarIdentity => ({
        photo: member.photo,
        avatar: member.avatar,
        color: member.color,
        links: member.links
    });

    // A care map's care recipient, with the name staff see as initials.
    forCareRecipient: IForCareRecipient = ((): IForCareRecipient => {
        const forLoadedCareMap = (careMap: ICareMap | INewCareMap): ICareRecipientAvatar => ({
            identity: this.forMember(careMap.patient),
            name: this.names.getName({ firstName: careMap.patient.firstName, lastName: careMap.patient.lastName })
        });

        function forCareRecipient(careMap: ICareMap | INewCareMap): ICareRecipientAvatar;
        function forCareRecipient(careMap: ICareMap | INewCareMap | undefined): ICareRecipientAvatar | { identity: undefined; name: string; };
        function forCareRecipient(careMap: ICareMap | INewCareMap | undefined): ICareRecipientAvatar | { identity: undefined; name: string; } {
            return careMap ? forLoadedCareMap(careMap) : { identity: undefined, name: '' };
        }
        return forCareRecipient;
    })();
}
